module.exports = __webpack_public_path__ + "static/media/instagram-a.97349806.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/AppFooter/assets/instagram-a.png
// module id = ./src/common/AppFooter/assets/instagram-a.png
// module chunks = 14